import { useItems } from './atoms/items-hook';
import CollectionKeys from './molecules/collection-keys';

const useAssociationReports = ({ filterQuery } = { filterQuery: {} }) => {
  const {
    items: associationReports,
    itemsLoading: associationReportsLoading,
    count,
    countLoading,
    pagination,
  } = useItems(CollectionKeys.ASSOCIATION_REPORTS, { filterQuery });

  const {
    items: associationReportsVariants,
    itemsLoading: associationReportsVariantsLoading,
  } = useItems(CollectionKeys.ASSOCIATION_REPORT_VARIANTS, {
    filterQuery: {
      _limit: -1,
      // imputation_in: [ false, null ],
    },
  });

  const associationReportsWithVariants = associationReports?.map((ar) => {
    const variants = associationReportsVariants
      ?.filter((arv) => { return arv.association_report.id === ar.id; })
      .map((arv) => { return { ...arv.variant, risk_allele: arv.risk_allele }; });
    return {
      ...ar,
      variants,
    };
  });

  return {
    associationReports: associationReportsWithVariants,
    associationReportsLoading: associationReportsLoading || associationReportsVariantsLoading,
    count,
    countLoading,
    pagination,
  };
};

export default useAssociationReports;

